<template>
  <div class="container">
    <crumb prevLevel="生产数据监管" current="药品生产入库" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="生产企业名称">
              <el-input v-model="entName" placeholder="请输入生产企业名称" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:20px" @click="init()"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ productionNum }}</div>
            <div class="text">生产企业总数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ productionRkNum }}</div>
            <div class="text">药品生产入库数量</div>
          </div>
        </div>
        <Echarts
          :echartsOption="echartsOption"
          echartsHeight="400px"
          @echartsClick="param => handler(param)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
export default {
  data() {
    return {
      entName: '',
      productionNum: '',
      productionRkNum: '',
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#666'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        series: [
          {
            name: '药品生产入库数量',
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: '#386CE2'
            },
            data: []
          }
        ]
      },
      supplierList: []
    };
  },
  components: {
    Echarts,
    Crumb
  },
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.EchartsData();
    },
    // ecarts 柱状图
    EchartsData() {
      const xData = [];
      const yData = [];
      this.$request({
        url: 'rest/production/productionRkStatics',
        data: {
          json: JSON.stringify({
            dict: {},
            params: {
              entName: this.entName
            }
          })
        }
      }).then(res => {
        this.productionNum = res.productionNum;
        this.productionRkNum = res.productionRkNum;
        res.list.forEach(item => {
          xData.push(item.ent_name);
          yData.push({
            value: item.rk_num,
            name: item.tax_no,
            id: item.organ_id
          });
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    handler(param) {
      const objData = {
        name: param.data.name,
        id: param.data.id
      };
      if (param.data.name) {
        this.$router.push({
          path: `/page/productingEnterprise/drugStockDetail`,
          query: {
            data: objData
          }
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
</style>
